import { u as c, s as C } from "../static-CPcCYSrK.js";
import { n as s } from "../property-4FoNj0Pi.js";
import { c as M } from "../lit-element-8JrrHldg.js";
import { o as m } from "../if-defined-Cd-e8xtV.js";
import { n as g } from "../ref-ArR26hg7.js";
import { I as H } from "../IdController-Cpj_A6H5.js";
import { P as E } from "../pwc-interactive-element-B6286Ky3.js";
import "./pwc-icon.js";
import { p as k } from "../pwcProperty-CTLG9yrF.js";
var O = Object.defineProperty, x = Object.getOwnPropertyDescriptor, i = (t, e, o, a) => {
  for (var n = a > 1 ? void 0 : a ? x(e, o) : e, l = t.length - 1, p; l >= 0; l--)
    (p = t[l]) && (n = (a ? p(e, o, n) : p(n)) || n);
  return a && n && O(e, o, n), n;
}, D = (t, e, o) => {
  if (!e.has(t))
    throw TypeError("Cannot " + o);
}, F = (t, e, o) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, o);
}, I = (t, e, o) => (D(t, e, "access private method"), o), f, u;
const b = "pwc-header-menu-item";
let r = class extends E {
  constructor() {
    super(...arguments), F(this, f), this.slotControlled = ["icon"], this.idController = new H(this, {
      base: "PwcHeaderMenuItem",
      children: ["form"]
    });
  }
  render() {
    const {
      slotted: t,
      isForm: e,
      label: o,
      icon: a,
      iconPath: n,
      action: l,
      method: p,
      target: $,
      csrfToken: d,
      href: _,
      idController: {
        id: v,
        child: { form: w }
      }
    } = this, y = () => {
      const h = c`<p-slot .host=${this} name="icon"></p-slot>`;
      return t.icon ? h : a != null && a.length ? c`${h}<pwc-icon icon=${a}></pwc-icon>` : n != null && n.length ? c`${h}<img src=${n} />` : h;
    };
    if (e)
      return c`
        <li class="PwcHeaderMenuItem" role="none">
          <button
            ref=${g(this.interactiveElementRef)}
            id=${v}
            form=${w}
            role="menuitem"
            type="submit"
            @click=${I(this, f, u)}
          >
            <div class="PwcHeaderMenuItem__icon">${y()}</div>
            <span class="PwcHeaderMenuItem__label"> ${o} </span>
          </button>
          <form
            id=${w}
            action=${m(l)}
            method=${m(p)}
            target=${m($)}
            aria-hidden="true"
          >
            ${d != null && d.length ? c` <input type="hidden" name="_token" value=${d} />` : ""}
          </form>
        </li>
      `;
    const P = C(_ ? "a" : "button");
    return c`
      <li
        class="PwcHeaderMenuItem"
        role="none"
      >
        <${P}
          ref=${g(this.interactiveElementRef)}
          id=${v}
          href=${m(_)}
          target=${m($)}
          role="menuitem"
          @click=${I(this, f, u)}
        >
          <div class="PwcHeaderMenuItem__icon">
            ${y()}
          </div>
          <span class="PwcHeaderMenuItem__label">
            ${o}
          </span>
        </${P}>
      </li>
    `;
  }
};
f = /* @__PURE__ */ new WeakSet();
u = function(t) {
  var e;
  (e = this.handler) == null || e.call(this), this.emit("p-menu-item-clicked", t);
};
r.tagName = b;
i([
  k({ type: Boolean, attribute: "is-form", default: !1 })
], r.prototype, "isForm", 2);
i([
  s()
], r.prototype, "label", 2);
i([
  s()
], r.prototype, "icon", 2);
i([
  s({ attribute: "icon-path" })
], r.prototype, "iconPath", 2);
i([
  s()
], r.prototype, "action", 2);
i([
  s()
], r.prototype, "method", 2);
i([
  s()
], r.prototype, "target", 2);
i([
  s({ attribute: "csrf-token" })
], r.prototype, "csrfToken", 2);
i([
  s()
], r.prototype, "href", 2);
i([
  s()
], r.prototype, "handler", 2);
r = i([
  M(b)
], r);
export {
  r as PwcHeaderMenuItem
};
